module.exports = __webpack_public_path__ + "media/newstyle/images/cta-desktop-red-46f7fb349ab7af5cc11b711662de4c6f.png";